<div class="p-4 flex flex-col gap-4">
  <!-- <mat-icon class="big-icon text-[var(--text-lightest)]">edit_document</mat-icon> -->
  <div class="w-full flex items-center justify-center">
    <ng-lottie [options]="options" width="150px" height="150px"></ng-lottie>
  </div>

  <div class="flex-1 text-center">
    <h2 class="font-semibold text-[var(--text)]">{{data.title}}</h2>
    <div *ngIf="data.currentDocument" class="w-full mb-4">
      <!-- <div class="text-sm text-[var(--text-lightest)] mb-1">Document en cours :</div> -->
      <div class="text-sm font-medium text-[var(--text-light)] truncate">{{data.currentDocument}}</div>
    </div>

    <mat-progress-bar mode="determinate" [value]="progressPercentage" class="w-full"></mat-progress-bar>

    <!-- Temps écoulé et estimé -->
    <div class="flex justify-between w-full text-xs text-[var(--text-lightest)]">
      <div>
        <span class="font-medium">Temps écoulé :</span> {{formatTime(timeElapsed)}}
      </div>
      <div *ngIf="estimatedTimeRemaining > 0">
        <span class="font-medium">Temps restant estimé :</span> {{formatTime(estimatedTimeRemaining)}}
      </div>
    </div>
  </div>
</div>

<!-- <div mat-dialog-content class="progress-dialog">
  <div class="flex items-center justify-center flex-col w-full p-6">
    <h2 class="text-xl font-semibold mb-4 text-center">{{data.title}}</h2>
    
    <div class="w-full mb-4">
      <div class="flex justify-between text-sm text-gray-600 mb-2">
        <span>{{data.currentProgress}} / {{data.totalDocuments}} documents</span>
        <span>{{progressPercentage}}%</span>
      </div>
      <div class="w-full bg-gray-200 rounded-full h-3">
        <div 
          class="bg-[var(--primary)] h-3 rounded-full transition-all duration-300 ease-out"
          [style.width.%]="progressPercentage">
        </div>
      </div>
    </div>

    <div *ngIf="data.currentDocument" class="w-full mb-4">
      <div class="text-sm text-gray-600 mb-1">Document en cours :</div>
      <div class="text-sm font-medium text-gray-800 truncate">{{data.currentDocument}}</div>
    </div>

    <div class="flex justify-between w-full text-sm text-gray-600">
      <div>
        <span class="font-medium">Temps écoulé :</span> {{formatTime(timeElapsed)}}
      </div>
      <div *ngIf="estimatedTimeRemaining > 0">
        <span class="font-medium">Temps restant estimé :</span> {{formatTime(estimatedTimeRemaining)}}
      </div>
    </div>

    <div class="relative size-8 mt-4">
      <div class="double-bounce1 bg-[var(--primary)]"></div>
      <div class="double-bounce2 bg-[var(--primary)]"></div>
    </div>
  </div>
</div>  -->